import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'or',
  months: [
    'ଜାନୁଆରୀ',
    'ଫେବୃଆରୀ',
    'ମାର୍ଚ',
    'ଏପ୍ରିଲ୍‌',
    'ମେ',
    'ଜୁନ୍‌',
    'ଜୁଲାଇ',
    'ଅଗଷ୍ଟ',
    'ସେପ୍ଟମ୍ୱର୍‌',
    'ଅକ୍ଟୋବର୍‌',
    'ନଭେମ୍ୱର୍‌',
    'ଡିସେମ୍ୱର୍‌',
  ],
  monthsShort: [
    'ଜାନୁଆରୀ',
    'ଫେବ୍ରୁଆରୀ',
    'ମାର୍ଚ୍ଚ',
    'ଏପ୍ରିଲ୍‍',
    'ମେ',
    'ଜୁନ୍',
    'ଜୁଲାଇ',
    'ଅଗଷ୍ଟ',
    'ସେପ୍ଟେମ୍ବର',
    'ଅକ୍ଟୋବର',
    'ନଭେମ୍ବର',
    'ଡିସେମ୍ବର',
  ],
  weekdays: ['ରବିବାର', 'ସୋମବାର', 'ମଙ୍ଗଳବାର', 'ବୁଧବାର', 'ଗୁରୁବାର', 'ଶୁକ୍ରବାର', 'ଶନିବାର'],
  weekdaysMin: ['ରବି', 'ସୋମ', 'ମଙ୍ଗଳ', 'ବୁଧ', 'ଗୁରୁ', 'ଶୁକ୍ର', 'ଶନି'],
  weekdaysShort: ['ରବିବାର', 'ସୋମବାର', 'ମଙ୍ଗଳବାର', 'ବୁଧବାର', 'ଗୁରୁବାର', 'ଶୁକ୍ରବାର', 'ଶନିବାର'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'h:mm A',
    lts: 'h:mm:ss A',
    L: 'M/D/YYYY',
    LL: 'MMMM D, YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'MMMM D',
    LLL: 'MMMM D, YYYY, HH:mm',
    'LLL-Y': 'MMMM D, HH:mm',
    LLLL: 'dddd, MMMM D, YYYY, HH:mm',
    'LLLL-Y': 'dddd MMMM D, HH:mm',
    l: 'M/D/YYYY',
    'l-Y': 'M/D',
    ll: 'MMM D, YYYY',
    'll-Y': 'MMM D',
    'll-D': 'MMM YYYY',
    lll: 'MMM D, YYYY, h:mm A',
    'lll-Y': 'MMM D, h:mm A',
    llll: 'ddd, MMM D, YYYY, h:mm A',
    'llll-Y': 'ddd, MMM D, h:mm A',
    'll-Y+w': 'ddd, MMM D',
    'LT+to': 'HH:mm ([GMT]Z)',
    'LLL+to': 'MMMM D, YYYY, HH:mm ([GMT]Z)',
  },
  meridiem: { am: 'am', pm: 'pm', AM: 'AM', PM: 'PM' },
  past: {
    y: { one: '%s ବ. ପୂର୍ବେ', other: '%s ବ. ପୂର୍ବେ' },
    M: { one: '%s ମା. ପୂର୍ବେ', other: '%s ମା. ପୂର୍ବେ' },
    w: { one: '%s ସପ୍ତା. ପୂର୍ବେ', other: '%s ସପ୍ତା. ପୂର୍ବେ' },
    d: { one: '%s ଦିନ ପୂର୍ବେ', other: '%s ଦିନ ପୂର୍ବେ' },
    h: { one: '%s ଘ. ପୂର୍ବେ', other: '%s ଘ. ପୂର୍ବେ' },
    m: { one: '%s ମି. ପୂର୍ବେ', other: '%s ମି. ପୂର୍ବେ' },
    s: { one: '%s ସେ. ପୂର୍ବେ', other: '%s ସେ. ପୂର୍ବେ' },
  },
  future: {
    y: { one: '%s ବ. ରେ', other: '%s ବ. ରେ' },
    M: { one: '%s ମା. ରେ', other: '%s ମା. ରେ' },
    w: { one: '%s ସପ୍ତା. ରେ', other: '%s ସପ୍ତା. ରେ' },
    d: { one: '%s ଦିନରେ', other: '%s ଦିନରେ' },
    h: { one: '%s ଘ. ରେ', other: '%s ଘ. ରେ' },
    m: { one: '%s ମି. ରେ', other: '%s ମି. ରେ' },
    s: { one: '%s ସେ. ରେ', other: '%s ସେ. ରେ' },
  },
  pastLong: {
    y: { one: '%s ବର୍ଷ ପୂର୍ବେ', other: '%s ବର୍ଷ ପୂର୍ବେ' },
    M: { one: '%s ମାସ ପୂର୍ବେ', other: '%s ମାସ ପୂର୍ବେ' },
    w: { one: '%s ସପ୍ତାହ ପୂର୍ବେ', other: '%s ସପ୍ତାହ ପୂର୍ବେ' },
    d: { one: '%s ଦିନ ପୂର୍ବେ', other: '%s ଦିନ ପୂର୍ବେ' },
    h: { one: '%s ଘଣ୍ଟା ପୂର୍ବେ', other: '%s ଘଣ୍ଟା ପୂର୍ବେ' },
    m: { one: '%s ମିନିଟ୍ ପୂର୍ବେ', other: '%s ମିନିଟ୍ ପୂର୍ବେ' },
    s: { one: '%s ସେକେଣ୍ଡ ପୂର୍ବେ', other: '%s ସେକେଣ୍ଡ ପୂର୍ବେ' },
  },
  futureLong: {
    y: { one: '%s ବର୍ଷରେ', other: '%s ବର୍ଷରେ' },
    M: { one: '%s ମାସରେ', other: '%s ମାସରେ' },
    w: { one: '%s ସପ୍ତାହରେ', other: '%s ସପ୍ତାହରେ' },
    d: { one: '%s ଦିନରେ', other: '%s ଦିନରେ' },
    h: { one: '%s ଘଣ୍ଟାରେ', other: '%s ଘଣ୍ଟାରେ' },
    m: { one: '%s ମିନିଟ୍‌‌ରେ', other: '%s ମିନିଟ୍‌‌ରେ' },
    s: { one: '%s ସେକେଣ୍ଡରେ', other: '%s ସେକେଣ୍ଡରେ' },
  },
  abbr: {
    y: { one: '%sବ.', other: '%sବ.' },
    M: { one: '%sମି', other: '%sମି' },
    w: { one: '%sସ', other: '%sସ' },
    d: { one: '%sଦି', other: '%sଦି' },
    h: { one: '%sଘ', other: '%sଘ' },
    m: { one: '%sମିନିଟ୍‌', other: '%sମିନିଟ୍‌' },
    s: { one: '%sସେ', other: '%sସେ' },
  },
  full: {
    y: { one: '%s ବର୍ଷ', other: '%s ବର୍ଷ' },
    M: { one: '%s ମାସ', other: '%s ମାସ' },
    w: { one: '%s ସପ୍ତାହ', other: '%s ସପ୍ତାହ' },
    d: { one: '%s ଦିନ', other: '%s ଦିନ' },
    h: { one: '%s ଘଣ୍ଟା', other: '%s ଘଣ୍ଟା' },
    m: { one: '%s ମିନିଟ୍‌', other: '%s ମିନିଟ୍' },
    s: { one: '%s ସେକେଣ୍ଡ', other: '%s ସେକେଣ୍ଡ' },
  },
  justNow: 'କେବଳ ବର୍ତ୍ତମାନ',
  yesterday: 'ଗତକାଲି',
  today: 'ଆଜି',
  tomorrow: 'ଆସନ୍ତାକାଲି',
  weekStart: 0,
  timeRange: '%$1s – %$2s',
  timeZone: '%$1s %$2s',
  timePref: {},
  timeRangeStyles: {
    yl: { start: 'MMMM D, YYYY', end: 'MMMM D, YYYY' },
    'yl-1': { start: 'MMMM D', end: 'MMMM D, YYYY' },
    ml: { start: 'MMMM D', end: 'MMMM D' },
    'ml-1': { start: 'YYYY MMMM D', end: 'D' },
    dl: { start: 'MMMM D', end: 'D' },
    y: { start: 'YYYY MMM D', end: 'YYYY MMM D' },
    'y-1': { start: 'YYYY MMM D', end: 'MMM D' },
    m: { start: 'MMM D', end: 'MMM D' },
    'm-1': { start: 'YYYY MMM D', end: 'D' },
    d: { start: 'MMM D', end: 'D' },
    Y: { start: 'YYYY MMM D, ddd', end: 'YYYY MMM D, ddd' },
    'Y-1': { start: 'YYYY MMM D, ddd', end: 'MMM D, ddd' },
    M: { start: 'MMM D, ddd', end: 'MMM D, ddd' },
    D: { start: 'MMM D, ddd', end: 'MMM D, ddd' },
    yt: { start: 'YYYY MMM D, HH:mm', end: 'YYYY MMM D, HH:mm' },
    mt: { start: 'MMM D, HH:mm', end: 'MMM D, HH:mm' },
    dt: { start: 'MMM D, HH:mm', end: 'MMM D, HH:mm' },
    t: { start: 'HH:mm', end: 'HH:mm' },
    'yt+to': { start: 'YYYY MMM D, HH:mm', end: 'YYYY MMM D, HH:mm ([GMT]Z)' },
    'mt+to': { start: 'MMM D, HH:mm', end: 'MMM D, HH:mm ([GMT]Z)' },
    'dt+to': { start: 'MMM D, HH:mm', end: 'MMM D, HH:mm ([GMT]Z)' },
    't+to': { start: 'HH:mm', end: 'HH:mm ([GMT]Z)' },
  },
};
const localeName: LocaleName = 'or';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  ordinal: (n) => `${n}`,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'am' : 'AM';
    } else {
      return isLowerCase ? 'pm' : 'PM';
    }
  },
};
